import { render, staticRenderFns } from "./ExhibitionGallery.vue?vue&type=template&id=c5adf4bc&"
import script from "./ExhibitionGallery.vue?vue&type=script&lang=js&"
export * from "./ExhibitionGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports